module.exports = __webpack_public_path__ + "img/loanapproval.1c1da233.svg";